define.alias("shared/components/shared/post/secondary/saved-captions/editor", "settings/components/shared/post/secondary/saved-captions/editor");